import { NO_CONTENT } from '../type_name'
export default {
    name: NO_CONTENT,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {

    },
    render(h) {
       
        return h('div', {
            style: {
                display: 'flex',
                width: '100%'
            }
        },)
    }
}